import {UserRole} from "../GraphQL/generated/graphql";

export const OrganizerWorkspaceRoles: UserRole[] = [
    UserRole.Administrator,
    UserRole.User,
];

export const hasOrganizerWorkspaceAccess = (roles: UserRole[] = []): boolean =>
    roles.some(role => OrganizerWorkspaceRoles.includes(role));

export const hasAdministratorRole = (roles: UserRole[] = []): boolean =>
    roles.includes(UserRole.Administrator);
